import { createFileRoute, redirect } from '@tanstack/react-router'
import type { JSX } from 'react'

import { invoicesApi } from '@/features/invoices/api'
import { InvoiceEditorPage } from '@/features/invoices/components/editor/invoice-editor-page'
import { isDraftGoneError } from '@/features/invoices/hooks/useInvoiceDraft'
import { appToast } from '@/lib/toast'

export const Route = createFileRoute('/_app/invoices/draft/$draftId')({
  // Valida en servidor que el borrador existe y pertenece al usuario autenticado antes
  // de montar el editor. El POST de creación es el único origen de un ID nuevo.
  loader: async ({ params }) => {
    try {
      return await invoicesApi.getDraft(params.draftId)
    } catch (error) {
      // Caso típico: el navegador restaura esta ruta al reabrirse días después y el TTL de
      // 7 días del borrador ya venció. No hay nada que editar — se vuelve al listado en
      // vez de montar el editor sobre un documento que ya no existe.
      if (isDraftGoneError(error)) {
        appToast.error('Este borrador expiró y ya no está disponible. Crea una factura nueva.')
        throw redirect({ to: '/invoices', replace: true })
      }
      throw error
    }
  },
  component: InvoiceDraftRoute,
})

function InvoiceDraftRoute(): JSX.Element {
  const { draftId } = Route.useParams()
  return <InvoiceEditorPage draftId={draftId} />
}
